<template>
  <router-view v-if="isReload"></router-view>
</template>

<script>
import { ref } from "vue";
export default {
  data() {
    return {
      global: {
        isShowCate: false,
        isShowCateLink: false,
        isOnCate: false,
      },
      isReload: true,
    };
  },
  provide() {
    return {
      global: this.global,
      reload: this.reload,
    };
  },
  methods: {
    reload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
  },
};
</script>
<style>
@import "//at.alicdn.com/t/c/font_2176559_mby6quxw4g.css";
</style>
